import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MentalHealthApp } from './MentalHealthApp';

const rootElement = document.getElementById('mental-health-form-root');

if (!rootElement) {
  throw new Error('Missing #mental-health-form-root element');
}

if (typeof stepFormAppSettings === 'undefined') {
  throw new Error('Missing stepFormAppSettings inline script');
}

createRoot(rootElement).render(
  <StrictMode>
    <MentalHealthApp settings={stepFormAppSettings} />
  </StrictMode>
);
